<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2025-01-22 14:23:59
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header
              @back="goBack"
              :content="editId == '' ? '新增账号' : '编辑账号'"
            >
            </el-page-header>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="用户账号" prop="account">
              <el-input
                v-model="ruleForm.account"
                placeholder="请输入用户账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户密码" prop="pass">
              <el-input
                v-model="ruleForm.pass"
                show-password
                placeholder="请输入用户密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel">
              <el-input
                v-model="ruleForm.tel"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role">
              <el-select
                v-model="ruleForm.role"
                placeholder="请选择"
                clearable
                style="margin-right: auto"
              >
                <el-option
                  v-for="item in ruleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-cascader
                style="margin-right: auto"
                :props="cateProps"
                :show-all-levels="false"
                v-model="ruleForm.department"
                :options="departmentList"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="是否客服"
              prop="select"
              style="display: flex; align-items: center"
            >
              <el-radio-group v-model="ruleForm.select">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="select"
              style="display: flex; align-items: center"
            >
              <el-radio-group v-model="ruleForm.state">
                <el-radio label="0">正常</el-radio>
                <el-radio label="1">冻结</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="客服昵称"
              prop="name"
              v-if="ruleForm.nickName != ''"
            >
              <el-input
                disabled
                v-model="ruleForm.nickName"
                placeholder="请输入客服昵称"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入用户名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="email" prop="email">
              <el-input
                v-model="ruleForm.email"
                placeholder="请输入email"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="close()">取消</el-button>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                style="margin-right: auto"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        account: "",
        name: "",
        role: "",
        tel: "",
        email: "",
        pass: "",
        department: "",
        select: "",
        state: "",
        nickName: "",
      },
      rules: {
        account: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        tel: [{ required: true, message: "必填项", trigger: "blur" }],
        role: [{ required: true, message: "必选项", trigger: "blur" }],
        department: [{ required: true, message: "必选项", trigger: "blur" }],
        state: [{ required: true, message: "必选项", trigger: "blur" }],
        select: [{ required: true, message: "必选项", trigger: "blur" }],
      },
      ruleList: [],
      departmentList: [],
      selectData: [], // 选择的部门回响数据
      editId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
    };
  },
  created: function () {
    this.getList();
    this.getList1();
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    handleChange(val) {
      this.ruleForm.department = val[val.length - 1];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            account: this.ruleForm.account,
            password: this.ruleForm.pass,
            phone: this.ruleForm.tel,
            roles: this.ruleForm.role,
            state: this.ruleForm.state,
            name: this.ruleForm.name,
            email: this.ruleForm.email,
            divisionId: this.ruleForm.department,
            isCustomerService: this.ruleForm.select,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/sys/users/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/sys/users/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.go(-1);
    },
    statusChange() {
      if (this.ruleForm.role.length > 1) {
        this.ruleForm.role.splice(0, 1);
      }
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 1000,
      };
      this.$axios
        .post(`/admapi/sys/roles/list`, param)
        .then(({ data }) => {
          this.ruleList = data.items;
        })
        .catch()
        .finally();
    },
    getDetail() {
      this.$axios
        .post(`/admapi/sys/users/get/${this.editId}`)
        .then(({ data }) => {
          this.ruleForm.name = data.name || "";
          this.ruleForm.account = data.account || "";
          this.ruleForm.role = Number(data.roles) || "";
          this.ruleForm.tel = data.phone || "";
          this.ruleForm.email = data.email || "";
          this.ruleForm.pass = data.password || "";
          this.ruleForm.status = data.status;
          this.ruleForm.state = JSON.stringify(data.status);
          this.ruleForm.nickName = data.hxNickName;
          this.ruleForm.select = JSON.stringify(data.isCustomerService);
          // this.selectData = [data.divisionId];
          this.ruleForm.department = data.divisionId;
        })
        .catch()
        .finally();
    },
    getList1() {
      let param = {
        page: 1,
        pageSize: 1000,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/division/treelist`, param)
        .then(({ data }) => {
          this.departmentList = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.el-form-item__content {
  margin-left: 0 !important;
}
</style>
